<form-control-container #container [control]="controlInstance" [class.readonly]="isReadonlyValue">
      <div label-extension>
        <ng-content select="[label-extension]"></ng-content>
      </div>
      <ng-container *ngIf="!isReadonlyValue">
        <div class='input-group'>
          <ng-content select="[before]"></ng-content>
          <input [ngModel]="internalValue"
                 (ngModelChange)="onInternalValueChanged($event)"
                 type="text"
                 class="form-control"
                 [maskito]="maskitoOptions"
                 [ngClass]="{invalid: hideValidationMessages ? null : invalid}"
                 [id]="controlId"
                 [attr.name]="inputName"
                 [disabled]="disabled"
                 (focusout)="touch()"
                 [autocomplete]="autocomplete ? 'on' : 'turn-off'"
                 [attr.tabindex]="tabindex"
                 [attr.placeholder]="placeholder" />
          <ng-content select="[after]"></ng-content>
        </div>
      </ng-container>
      <ng-container *ngIf="isReadonlyValue">
        <span class="readonly-value">{{internalValue}}</span>
      </ng-container></form-control-container>
